import { render, staticRenderFns } from "./EventPopover.vue?vue&type=template&id=7bf962c3&scoped=true&"
import script from "./EventPopover.vue?vue&type=script&lang=ts&"
export * from "./EventPopover.vue?vue&type=script&lang=ts&"
import style0 from "./EventPopover.vue?vue&type=style&index=0&id=7bf962c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bf962c3",
  null
  
)

export default component.exports